<template>
    <span>
        <span v-if="reservation.sign_status === 'SIGNED'">
            <a
                :href="
                    reservation &&
                    reservation.signed_agreement &&
                    reservation.signed_agreement.absolute_url
                "
            >
                <img :src="`/static/images/icons/reservation/signed_bg_${size}.svg`" title="Signed" />
            </a>
        </span>
        <span v-else-if="reservation.sign_status === 'PENDING'">
            <img
                :src="`/static/images/icons/reservation/sign_pending_bg_${size}.svg`"
                title="Pending"
            />
        </span>
        <span
            style="cursor: pointer"
            v-else-if="reservation.sign_status === 'UNSIGNED'"
            @click="showModal"
        >
            <img :src="`/static/images/icons/reservation/unsigned_bg_${size}.svg`" title="Unsigned" />
        </span>
        <span v-else></span>
    </span>
</template>

<script>
export default {
    props: {
        reservation: Object,
        size: {
            type: String,
            default: '24'
        },        
    },
    methods: {
        showModal() {
            this.$emit('sign-click');
        },
    },
};
</script>